import config from './config'
import string from './string'

const utilis ={
  
    config,
    string

    
}

export default utilis